import React from "react";
import { Tooltip, Typography } from "antd";
import { shorterString, escapeRegExp } from "../utils/string";
import { formatSSNToDisplay } from "../utils/formaters";

const { Text } = Typography;

function HighlightResult(text, searchInput, maxLength) {
  let shortenedText = text;
  if (maxLength) {
    shortenedText = shorterString(text, maxLength);
  }
  if (!searchInput) {
    return shortenedText;
  }

  searchInput = escapeRegExp(searchInput);

  let regex = new RegExp("(" + searchInput + ")", "ig");
  let result = `<Text>${shortenedText?.replaceAll(regex, "<b>$1</b>")}</Text>`;

  // Also search for SSN matches
  const alphaCheck = /[a-zA-Z+]/.test(searchInput);
  if (!alphaCheck) {
    const alternateInput = formatSSNToDisplay(searchInput);
    regex = new RegExp("(" + alternateInput + ")", "ig");
    result = result?.replaceAll(regex, "<b>$1</b>");
  }

  return result;
}

const ShorterTextWithTooltip = ({ text, maxLength, strong = false, ...props }) => (
  <>
    {text.length > maxLength && (
      <Tooltip title={<Text>{text}</Text>} color={"white"}>
        <Text strong={strong} {...props}>
          {shorterString(text, maxLength)}
        </Text>
      </Tooltip>
    )}
    {text.length <= maxLength && (
      <Text strong={strong} {...props}>
        {text}
      </Text>
    )}
  </>
);

const SearchTermWithTooltip = ({ text, maxLength, searchInput, textStyle, ...props }) => {
  return (
    <>
      {text && text.length > maxLength && (
        <Tooltip title={<Text>{text}</Text>} color={"white"}>
          <div
            dangerouslySetInnerHTML={{ __html: HighlightResult(text, searchInput, maxLength) }}
            style={textStyle}
            {...props}
          ></div>
        </Tooltip>
      )}
      {text && text.length <= maxLength && (
        <div
          dangerouslySetInnerHTML={{ __html: HighlightResult(text, searchInput, maxLength) }}
          style={textStyle}
          {...props}
        ></div>
      )}
    </>
  );
};

export { ShorterTextWithTooltip, SearchTermWithTooltip, HighlightResult };
